import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-events-administration-base",
  templateUrl: "./events-administration-base.component.html",
  styleUrls: ["./events-administration-base.component.scss"],
})
export class EventsAdministrationBaseComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}
  ngOnInit(): void {
    // Only navigate to 'show-all-events' if no child route is active
    if (this.route.snapshot.children.length === 0) {
      this.router.navigate(["show-all-events"], { relativeTo: this.route });
    }
  }
}
